import { render, staticRenderFns } from "./LexusBbsShow.vue?vue&type=template&id=8ea3d8d4&"
import script from "./LexusBbsShow.vue?vue&type=script&lang=js&"
export * from "./LexusBbsShow.vue?vue&type=script&lang=js&"
import style0 from "./LexusBbsShow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports